import React, { useState, useEffect } from "react";
import { IconContext } from "react-icons";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Navbar_black.css";
import { SidebarData_black } from "./SidebarData_black";
import Footer_black from './Footer_black';

function Navbar_black() {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);

  useEffect(() => {
    const setWindowDimensions = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      document.documentElement.style.setProperty('--adjusted-width', `calc(${windowWidth}px - 10%)`);
      document.documentElement.style.setProperty('--adjusted-height', `calc(${windowHeight}px - 10%)`);
    };

    setWindowDimensions();

    window.addEventListener('resize', setWindowDimensions);

    return () => {
      window.removeEventListener('resize', setWindowDimensions);
    };
  }, []);

  const handleClick = (item) => {
    if (item.protected) {
      return; // Skip handling click for protected items
    }

    // Perform action for non-protected items
    // ...
  };

  return (
    <>
      <div className={`navbar_black ${sidebar ? "active" : ""}`}>
        <Link to="#" className="menu-bars_black" onClick={showSidebar}>
        
            <FaIcons.FaBars onClick={showSidebar} />
          
        </Link>
      </div>
      <nav className={sidebar ? 'nav-menu_black active' : 'nav-menu_black'}>
        <ul className="nav-menu-items_black" onClick={showSidebar}>
          {SidebarData_black.map((item, index) => {
            return (
              <li key={index} className={item.cName}>
                {item.protected ? (
                  <span className="protected-item_black">
                    {item.title}
                  </span>
                ) : (
                  <Link to={item.path} onClick={() => handleClick(item)}>
                    {item.title}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </nav>
      <Footer_black />
    </>
  );
}

export default Navbar_black;

